import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Instagram } from 'lucide-react';
import { Logo } from './Logo';
import { useVehicles } from '../contexts/VehiclesContext';
export function Footer() {
  const {
    openAdmin
  } = useVehicles();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-[#050505] pt-20 pb-10 border-t border-brand-gold/20" data-id="element-335" data-mp="3qc44ji8q6cot">
      <div className="max-w-7xl mx-auto px-6" data-id="element-336" data-mp="29y5i442prqwl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-337" data-mp="2a1jl9ej7c453">
          {/* Brand Col */}
          <div className="lg:col-span-2" data-id="element-338" data-mp="3l9k7pidf7xfx">
            <Logo className="mb-6" data-id="element-339" data-mp="3labpnqe3hwnq" />
            <p className="text-brand-gold font-bold tracking-widest text-sm mb-6" data-id="element-340" data-mp="3lbmw5xyxdiij">
              RÁPIDO, SIMPLE, CONFIABLE.
            </p>
            <p className="text-brand-white/60 text-sm max-w-sm" data-id="element-341" data-mp="3v89fgibls1ig">
              Tu socio estratégico en el mercado automotor argentino. Compra,
              venta, alquiler e inversiones.
            </p>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-342" data-mp="80xjq7w8kzj3">
            <h4 className="text-brand-white font-bold mb-6" data-id="element-343" data-mp="80nvaoqub0fi">Servicios</h4>
            <ul className="space-y-4" data-id="element-344" data-mp="33nm44yp1hk6">
              <li data-id="element-345" data-mp="hsk1yo6zryvc">
                <button onClick={() => scrollToSection('compra-venta')} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-346" data-mp="ht3c3iqehiyt">
                  Compra y Venta
                </button>
              </li>
              <li data-id="element-347" data-mp="ms6dmt769721">
                <button onClick={() => scrollToSection('alquiler')} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-348" data-mp="mspq3ue1z38o">
                  Alquiler para Apps
                </button>
              </li>
              <li data-id="element-349" data-mp="13sr4aua3p5rm">
                <button onClick={() => scrollToSection('consignacion')} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-350" data-mp="13s9ae4awv3mv">
                  Consignación
                </button>
              </li>
              <li data-id="element-351" data-mp="1hk5xtv1mwpcx">
                <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-352" data-mp="1hjnvcgodpewk">
                  Inversiones
                </a>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-353" data-mp="3ta86l8ynyh68">
            <h4 className="text-brand-white font-bold mb-6" data-id="element-354" data-mp="3t9q59xx59crg">Empresa</h4>
            <ul className="space-y-4" data-id="element-355" data-mp="2af3rlmvaexi1">
              <li data-id="element-356" data-mp="2ag5firxejeh6">
                <button onClick={() => window.scrollTo(0, 0)} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-357" data-mp="2agonbftc8mhh">
                  Inicio
                </button>
              </li>
              <li data-id="element-358" data-mp="1wo8pctfanenf">
                <button onClick={() => scrollToSection('contacto')} className="text-brand-white/60 hover:text-brand-gold transition-colors text-sm" data-id="element-359" data-mp="1wos11secp6t0">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div data-id="element-360" data-mp="2kfe6rd0vuezu">
            <h4 className="text-brand-white font-bold mb-6" data-id="element-361" data-mp="2fe6ylcutvdsn">Contacto</h4>
            <ul className="space-y-4 text-sm text-brand-white/60" data-id="element-362" data-mp="2fdylpkypg8hg">
              <li data-id="element-363" data-mp="18z5ycuyrs9g9">Los Patos 2927, Parque Patricios CABA</li>
              <li data-id="element-364" data-mp="13z1jf9difms5">Lunes a sábados 9 a 19hs</li>
              <li data-id="element-365" data-mp="13y9xkq9pt3f2">+54 9 11 2706-3704</li>
            </ul>
            <div className="flex gap-4 mt-6" data-id="element-366" data-mp="2rvzlfa75dzs4">
              <a href="https://wa.me/5491127063704" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#111] border border-brand-gold/30 flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-367" data-mp="2ruy08cwf3wwo">
                <MessageCircle className="w-5 h-5" data-id="element-368" data-mp="3bk029ws7v8ij" />
              </a>
              <a href="https://instagram.com/flash.go.arg" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#111] border border-brand-gold/30 flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-369" data-mp="3bhm9jul0e8e5">
                <Instagram className="w-5 h-5" data-id="element-370" data-mp="1q5m5lzx7zvck" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-gold/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-371" data-mp="1v71n5i06vjq7">
          <p className="text-brand-white/40 text-sm" data-id="element-372" data-mp="1nnsfpub8tv3s">
            © 2026 Flash & Go — Todos los derechos reservados
          </p>
          <button type="button" onClick={openAdmin} className="text-brand-white/30 hover:text-brand-gold transition-colors text-xs" data-id="element-373" data-mp="1wn5savunyzsq">
            Admin
          </button>
        </div>
      </div>
    </footer>;
}